import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        is_mobi:null,//判断平台
        editDish:{},
        editList:[],
        warehouseList:[],
        inventoryData:{},
        addItem:{},
        peopleMsg:{},//审核注册账号的信息
        editRole:{},//编辑系统角色权限、描述
        isShowLoading:false,//展示请求中loading
        selectList:[],//用于各种选中项的缓存,
        index:0,
        auditList:[],
        flag:false,
        is_save:true,
        isShowNav:true,
        waitTip:{
          unconfirmPay_nums:0,//待确认付款订单数
          unconfirmRefund_nums:0,//待确认退款订单数
          unapprovePay_nums:0,//待审核付款订单数
          unapproveRefund_nums:0//待审核退款订单数
        },
        rushScore:false,
        workFlow:{
          pending:0,
          list:[]
        }
	},
    mutations: {
        changeWorkFlow(state,value){
          state.workFlow=value;
        },
        changeRushScore(state,value){
          state.rushScore=value;
        },
        changeWaitTip(state,value){
          state.waitTip=value;
        },
        changeNav(state,value){
          state.isShowNav=value;
        },
        changeIndex(state,value){
          state.index=value;
        },
        changeMobi(state,value){
          state.is_mobi=value;
        },
        changeEditDish(state,value){
          state.editDish=value;
        },
        changeEditList(state,value){
          state.editList=value;
        },
        changeWarehouseList(state,value){
          state.warehouseList=value;
        },
        changeInventoryData(state,value){
          state.inventoryData=value;
        },
        changeAddItem(state,value){
          state.addItem=value;
        },
        changePeopleMsg(state,value){
          state.peopleMsg=value;
        },
        changeEditRole(state,value){
          state.editRole=value;
        },
        changeShowLoading(state,value){
          state.isShowLoading=value;
        },
        changeSelectList(state,value){
          state.selectList=value;
        },
        changeAuditList(state,value){
          state.auditList=value;
        },
        routerFlag(state,value){
          state.flag=value;
        },
        changeSave(state,value){
          state.is_save=value;
        }
	},
    actions: {}
})
export default store
